/******************************************************************************
 *
 * Copyright (c) 2019-2023 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Rahul Bagaria’ <rhaul@wakencode.com>, September 2023
 *
 *****************************************************************************/

import React, { Component } from "react";
import styles from "./Loading.module.css";
import { ChasingDots } from "styled-spinkit";

class LoadingWithoutAuth extends Component {
  render() {
    return (
      <div className={styles.Backdrop}>
        <ChasingDots color="#F28E1A" size={45} />
      </div>
    );
  }
}

export default LoadingWithoutAuth;
